import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ERROR, SOMETHING_WENT_WRONG, SUCCESS } from '../../utils/constants';
import ChartDataByAge from './AHMIS/ChartDataByAge';
import ChartDataByDailyPatient from './AHMIS/ChartDataByDailyPatient';
import ChartDataByMonth from './AHMIS/ChartDataByMonth';
import ChartDataBySewaType from './AHMIS/ChartDataBySewaType';
import styles from "./style";
import ChartDataByNewOldPatient from './AHMIS/ChartDataByNewOldPaient';
import AHMIS, { API_URL } from '../../api/api';
import AddAlertMessage from '../alert/Alert';
const Dashboard = () => {
  const [dashboard, setDashboard] = useState({})


  useEffect(() => {
    getDashboardData()
  }, [])

  const getDashboardData = () => {
    const url = `${API_URL.dashboard}`;
    AHMIS.get(url).then(response => {
      const jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        setDashboard(jsondata?.data);
      } else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      }
    }).catch(error => {
      AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
    });
  };

  const classes = styles();

  return (
    <>
      <Box className={classes.registerHeaderContainer} borderBottom={1}>
        <Typography variant="h6" className={classes.registerTitle}>गृहपृष्ठ</Typography>
      </Box>
      <Grid container spacing={2}>
        <>
          <Grid item xs={12}>
            <ChartDataByDailyPatient ChartDataByDailyPatient={dashboard} />
          </Grid>
          <Grid item xs={12}>
            <ChartDataByMonth chartDataByMonth={dashboard} />
          </Grid>
          <Grid item xs={12}>
            <ChartDataByAge chartDataByAge={dashboard} />
          </Grid>
          <Grid item xs={12}>
            <ChartDataBySewaType chartDataBySewa={dashboard} />
          </Grid>
          <Grid item xs={12}>
            <ChartDataByNewOldPatient chartDataByNewOld={dashboard} />
          </Grid>
        </>
      </Grid>
    </>
  )
}

export default Dashboard;